import {queryOptions} from '@tanstack/react-query';
import {groupsRetrieve} from 'api/v2';

export const groupsQueryKeys = {
  all: () => ['group'],
  detail: (id: string) => [...groupsQueryKeys.all(), 'detail', id],
};

const groupsDetail = (id: string) =>
  queryOptions({
    queryKey: groupsQueryKeys.detail(id),
    queryFn: () => groupsRetrieve(id),
    select: (data) => data.data,
  });

export const groupsQueryOptions = {
  detail: groupsDetail,
};
